import * as React from "react";
import { Link } from "react-router-dom";
import { routes } from "../../../appRoutingHelpers";
import { OrganizationKeyName } from "../../../model/Organization";
import { PunchCardType } from "../../../service/api-response/PunchCards";

interface Props {
  punchCard: PunchCardType;
  organization: OrganizationKeyName;
}

export const ProductPackRow: React.FC<Props> = ({
  punchCard,
  organization,
}) => {
  return (
    <tr>
      <td>{punchCard.name}</td>
      <td>{punchCard.products.length}</td>
      <td className="text-right">
        <div className="btn-group">
          <Link
            className="btn btn-sm btn-primary"
            to={routes.punchCardsEdit(organization, punchCard.id!)}
          >
            Edit
          </Link>
        </div>
      </td>
    </tr>
  );
};

export default ProductPackRow;
